import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What does ’no results, no pay’ actually mean?",
    a: "It means exactly that. You don’t pay a setup fee, a retainer, or a subscription. We only invoice you for closed revenue that we directly produce — verified inside your CRM. If the campaign generates nothing, you owe nothing.",
  },
  {
    q: "How long does reactivation take?",
    a: "Most clients see their first booked appointment within 5–10 days of campaign launch. A full reactivation cycle runs 60–90 days, with messaging cadences tuned to your industry and customer behavior.",
  },
  {
    q: "Do I need to hand over my database?",
    a: "No. We work inside your CRM (HubSpot, GoHighLevel, Pipedrive, Klaviyo, etc.) or with a one-time CSV upload that stays on your side. We sign mutual NDAs before we see a single contact.",
  },
  {
    q: "What if my database is small or old?",
    a: "Great question — dormant contacts who haven’t been touched in 6+ months do convert surprisingly well, dependent on your offer. Ideally, once we have your trust, the newer the lead the better the closing ratio your team will enjoy.",
  },
  {
    q: "What industries do you work with?",
    a: "We’ve reactivated databases for med spas, real estate brokerages, home services, dental, fitness, coaching, and e-commerce. If your business has a ’list of people who almost bought,’ we can probably help.",
  },
  {
    q: "How do you calculate your fee?",
    a: "We only get paid when you do. Before we begin, we agree a simple performance-based revenue share that’s fair to both sides. There are no upfront costs, no retainers and no hidden charges — just complete transparency and reporting, so you can clearly see the results we’ve delivered.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 lg:py-32 border-b border-white/10"
    >
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          <div className="lg:col-span-1">
            <div className="text-xs uppercase tracking-[0.25em] text-[#ccff00] font-semibold mb-4">
              / FAQ
            </div>
            <h2 className="font-display text-4xl sm:text-5xl uppercase">
              Skeptical?
              <br />
              <span className="text-white/40">Good.</span>
            </h2>
            <p className="mt-6 text-white/60 text-sm leading-relaxed">
              You should be. Here’s what every business owner asks before we
              ever shake hands.
            </p>
          </div>
          <div className="lg:col-span-2">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i + 1}`}
                  className="border-b border-white/10 last:border-b-0"
                >
                  <AccordionTrigger className="text-left py-6 hover:no-underline text-base lg:text-lg font-display uppercase tracking-tight">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-white/60 leading-relaxed pb-6 text-sm">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
